import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	loadingPopup: {
		borderRadius: "0.5rem !important",
		width: "unset !important",
	},
	dialogRoot: { padding: "0px" },
	progress: {
		margin: theme.spacing(4),
	},
	container: {
		height: "180px",
		width: "180px",
		justifyContent: "center",
		maxWidth: "100%",
		padding: "0px",
	},
	logoWrapper: {
		position: "relative",
		width: "80%",
		height: "132px",
	},
	title: {
		fontSize: "14px",
		position: "relative",
		top: "-22px",
	},
	loaderImage: {
		width: "108px",
		display: "block",
		margin: "auto",
	},
});
